<template>
  <div class="run-eod-card row mb-2">
    <div class="col-12">
      <p class="title">End Of Day Report</p>
      <p class="sub">some basic info on How to Run EOD</p>
      <p class="text-left">
        <span v-if="loader.actionButtonLoader" class="formLoaderHold">
          <BaseComponentLoader />
        </span>
        <span v-else>
          <button @click="runEod()" class="btn btn-primary action-btn">
            Run
          </button>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import StoreUtils from "../../../../../utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";

export default {
  name: "RunEodCard",
  computed: {
    ...mapState(["loader"])
  },
  methods: {
    runEod() {
      StoreUtils.dispatch(StoreUtils.actions.eod.RUN_EOD);
    }
  }
};
</script>

<style scoped>
.title {
  margin-bottom: 5px;
  font-size: 18px;
  line-height: 22px;
  font-weight: 800;
  color: #546ee6;
}
.sub {
  margin-bottom: 10px;
}
.action-btn {
  margin-bottom: 30px;
}
</style>
